import {InspectableState} from './types';
import {inspectableObject} from './object';
import {inspectablePrimitive} from './primitive';

export function inspectable(state?: StorableState): InspectableState {
  if (!state) return null;

  const budget = inspectableObject(state.budget);
  const history = state.history.map((record) => inspectableObject(record));
  const lastRecalcDateTime = inspectablePrimitive(state.lastRecalcDateTime);
  return {...state, budget, history, lastRecalcDateTime};
}
